import { render, staticRenderFns } from "./addserverAd.vue?vue&type=template&id=5dd78ce8&"
import script from "./addserverAd.vue?vue&type=script&lang=js&"
export * from "./addserverAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd78ce8')) {
      api.createRecord('5dd78ce8', component.options)
    } else {
      api.reload('5dd78ce8', component.options)
    }
    module.hot.accept("./addserverAd.vue?vue&type=template&id=5dd78ce8&", function () {
      api.rerender('5dd78ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/components/addserverAd.vue"
export default component.exports